import type { PlyrProps } from 'plyr-react';
import { lazy, Suspense } from 'react';

const Plyr = lazy(() => import('plyr-react'));

export const VideoPlayer = (props: PlyrProps) => {
  const isBrowser = typeof window !== 'undefined';

  if (!isBrowser) {
    return null;
  }

  return (
    <Suspense fallback={<div />}>
      <Plyr {...props} />
    </Suspense>
  );
};
